import { render, staticRenderFns } from "./flightpath-newpassword.vue?vue&type=template&id=515de40a"
import script from "./flightpath-newpassword.vue?vue&type=script&lang=ts"
export * from "./flightpath-newpassword.vue?vue&type=script&lang=ts"
import style0 from "./flightpath-newpassword.vue?vue&type=style&index=0&id=515de40a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515de40a')) {
      api.createRecord('515de40a', component.options)
    } else {
      api.reload('515de40a', component.options)
    }
    module.hot.accept("./flightpath-newpassword.vue?vue&type=template&id=515de40a", function () {
      api.rerender('515de40a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/flightpath-newpassword.vue"
export default component.exports